/** Hooks TanStack Query pour la gestion des bornes */

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { readersApi } from '../services/api';
import type { ReaderCreate } from '../types';

export function useReaders(site_id?: number) {
  return useQuery({
    queryKey: ['readers', site_id],
    queryFn: () => readersApi.list(site_id),
  });
}

export function useCreateReader() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: ReaderCreate) => readersApi.create(data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['readers'] }),
  });
}

export function useUpdateReader() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: Partial<ReaderCreate> }) =>
      readersApi.update(id, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['readers'] }),
  });
}

export function useDeleteReader() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => readersApi.delete(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['readers'] }),
  });
}

export function useCreatePairingCode() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => readersApi.createPairingCode(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['readers'] }),
  });
}

export function useRevokeDevice() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => readersApi.revokeDevice(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['readers'] }),
  });
}
